import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { Form, Text } from 'react-form';
import validator from 'validator';
import s from '../../markup/src/sass/app.scss';
import Link from '../../components/Link/Link';
import imgLogo from '../../markup/src/img/logo.svg';
import imgRestoreImg from '../../markup/src/img/restore-img.svg';
import App from '../../components/App';
import readError from '../../components/Form/ReadError';
import haveError from '../../components/Form/HaveError';
import NotificationEmitter from '../../components/NotificationCenter/NotificationEmitter';

class ForgotPassword extends React.Component {
  static contextTypes = {
    fetch: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      isLoading: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    document.body.classList.add(s['sign-body']);
  }

  componentWillUnmount() {
    document.body.classList.remove(s['sign-body']);
  }

  async onSubmit(values, e, formApi) {
    if (this.state.isLoading) {
      return;
    }

    this.setState({ isLoading: true });

    try {
      await this.context.fetch('/user/forgot-password', {
        method: 'PUT',
        body: JSON.stringify({
          email: values.email,
        }),
      });

      NotificationEmitter.add({
        message: 'Check your email for further instructions',
        level: 'success',
      });

      this.setState({ isLoading: false });
    } catch (err) {
      if (err.code === 422) {
        formApi.setFormState({
          ...formApi.getFormState(),
          errors: err.data,
        });

        this.setState({ isLoading: false });
      } else {
        NotificationEmitter.add({
          message: 'Error on resetting password',
          level: 'error',
        });

        this.setState({
          isLoading: false,
        });
      }
    }
  }

  render() {
    return (
      <div className={s['sign-inner']}>
        <div className={`${s['sign-block-wrap']} ${s['center-block']} ${s[this.state.isLoading ? 'loading' : null]}`}>
          <Form
            validateOnSubmit
            onSubmit={this.onSubmit}
            validate={values => ({
              email: validator.isEmpty(values.email || '') ? 'Required' : !validator.isEmail(values.email || '') ? 'Wrong email' : null,
            })}
          >
            {formApi => (
              <form
                onSubmit={e => {
                  e.preventDefault();
                  formApi.setFormState({
                    ...formApi.getFormState(),
                    errors: [],
                  });
                  formApi.submitForm();
                }}
              >
                <div className={`${s['sign-block']} ${s['mb-5']}`}>
                  <header className={`${s['sign-block-header']} ${s.clearfix} ${s['mb-3']}`}>
                    <Link className={s['navbar-logo']} to="#">
                      <img className={s['navbar-logo-img']} src={imgLogo} />Pasco Calendar
                    </Link>
                  </header>
                  <div className={s['sign-block-inner']}>
                    <p className={`${s['text-lg']} ${s['text-primary-darker']} ${s['mb-3']}`}>
                      <i>Please enter your email for us to sent you recovery instructions:</i>
                    </p>

                    <div className={`${s['form-group']} ${s['mb-5']} ${s[haveError(formApi.errors, 'email') ? 'form-group-danger' : null]}`}>
                      <span className={s['form-label']}>Email:</span>
                      <Text className={s['form-control']} type="text" field="email" />
                      <div className={`${s['pt-2']} ${s.clearfix}`}>
                        {haveError(formApi.errors, 'email') && (
                          <div className={s['pull-left']}>
                            <span className={`${s['text-danger']} ${s['text-sm']}`}>
                              <i>{readError(formApi.errors, 'email')}</i>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <footer className={s['sign-block-footer']}>
                    <div className={`${s.clearfix} ${s['mb-8']}`}>
                      <button disabled={this.state.isLoading} type="submit" className={`${s['btn-shade']} ${s['pull-right']}`}>
                        Restore My Password
                      </button>
                    </div>
                    <img className={`${s['center-block']} ${s['img-responsive']}`} width="208" height="97" src={imgRestoreImg} />
                  </footer>
                </div>
              </form>
            )}
          </Form>
          <p className={`${s['mb-0']} ${s['text-xs']} ${s['text-right']} ${s['text-gray']}`}>{App.getCopyright()}</p>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ForgotPassword);
